import { render } from "./cashbox.vue?vue&type=template&id=51dc49a4"
import script from "./cashbox.vue?vue&type=script&lang=js"
export * from "./cashbox.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__